import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import rootReducer from '../slices'; // Your root reducer
import { injectStore, injectUiAnalyticsEvents } from '../Utils/axiosInstance';
import { uiAnalyticsEvents } from '../slices/UIAnalyticsSlice';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

// Break the circular dependency: inject store + analytics action into
// axiosInstance AFTER the store is fully initialized.
injectStore(store);
injectUiAnalyticsEvents(uiAnalyticsEvents);

const persistor = persistStore(store);

export { store, persistor };
